// extracted by mini-css-extract-plugin
module.exports = {"headerLogo":"ZYspp","center":"bdU1V","logo":"ObTzR","logoLink":"WZZkQ"};